import colorMapping from "./components/colorMapping";

const getColorFromMap = (value, mapping) => {
    const match = mapping.find(
        (range) => value >= range.min && value < range.max
    );

    return match ? match.color : '#918d8f';
};

const kbdiColor = (value) =>
    getColorFromMap(value, colorMapping.kbdi);

const ignitionComponentColor = (value) =>
    getColorFromMap(value, colorMapping.ignition_component);

const spreadComponentColor = (value) =>
    getColorFromMap(value, colorMapping.spread_component);

const energyReleaseComponentColor = (value) =>
    getColorFromMap(value, colorMapping.energy_release_component);

const burningIndexColor = (value) =>
    getColorFromMap(value, colorMapping.burning_index);

const tenHrFuelIndexColor = (value) =>
    getColorFromMap(value, colorMapping.tenhrfm);

const hunHrFuelIndexColor = (value) =>
    getColorFromMap(value, colorMapping.hunhrfm);

const thHrFuelIndexColor = (value) =>
    getColorFromMap(value, colorMapping.thhrfm);

export {
    burningIndexColor,
    kbdiColor,
    ignitionComponentColor,
    spreadComponentColor,
    energyReleaseComponentColor,
    tenHrFuelIndexColor,
    hunHrFuelIndexColor,
    thHrFuelIndexColor
};